// Shared react-select style fragments for the Stage/Strategy controls, so a fix to one no longer
// leaves a sibling's own copy silently unfixed. Consumed by pages/PropertyDashboard.jsx (Stage,
// Strategy) and grid/StageCellEditor.jsx (Stage).

// react-select's own default groupHeadingCSS bakes in textTransform: 'uppercase' — spreading `base`
// without overriding it here leaves that default in effect. Node Group 931/stage-dropdown draws
// these headings title case.
export const groupHeadingStyle = (base) => ({
  ...base,
  fontSize: 11,
  fontWeight: 700,
  color: '#17270D',
  textTransform: 'none',
  letterSpacing: '0.04em',
});

// brand.placeholder — the token every other empty field on these two screens already uses (Add
// Opportunity's dashes, the Notes placeholder). fontSize matches each site's own option/control text.
// lineHeight: 'normal' -- same CSS2.1 strut defect as singleValueStyle (grid/README.md).
export const placeholderStyle = (base) => ({
  ...base,
  color: '#8A9A85',
  fontSize: 13,
  lineHeight: 'normal',
});
